import api from '../api/api';

const pageCache = new Map();
let inflight = new Map();
let lastListPage = 1;

export function getLastBlogsListPage() {
  return lastListPage || 1;
}

export function setLastBlogsListPage(page) {
  const n = Number(page);
  lastListPage = Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
}

export function getBlogsPageCache(page = 1) {
  return pageCache.get(page) || null;
}

export async function loadBlogsPage(page = 1, { force = false } = {}) {
  if (!force && pageCache.has(page)) {
    return pageCache.get(page);
  }
  if (!force && inflight.has(page)) {
    return inflight.get(page);
  }

  const request = api
    .get('/api/v1/pdf_parser/blogs/', { params: { page } })
    .then(({ data }) => {
      const result = {
        blogs: data?.blogs || [],
        count: data?.count ?? 0,
        next: data?.next ?? null,
        previous: data?.previous ?? null,
        page: data?.page ?? page,
        pageSize: data?.page_size ?? 25,
        totalPages: data?.total_pages ?? 1,
      };
      pageCache.set(page, result);
      inflight.delete(page);
      return result;
    })
    .catch((err) => {
      inflight.delete(page);
      throw err;
    });

  inflight.set(page, request);
  return request;
}

/** @deprecated Use loadBlogsPage — kept for compatibility */
export function getBlogsCache() {
  return getBlogsPageCache(1)?.blogs || null;
}

/** @deprecated Use loadBlogsPage */
export async function loadBlogs(options) {
  const result = await loadBlogsPage(1, options);
  return result.blogs;
}
